import { createApp } from 'vue';
import Landing from './Landing.vue';
import 'sass/landing.scss';
import { registerUiDirectives } from './utils/Ui';

const app = createApp(Landing);
registerUiDirectives(app);
app.mount('#app');
